function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#517ED3;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Ic2cHf.tif_00000029036394132710176270000014944501240421855881_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.2,25c-4.9,0-9.8,0-14.7,0c-0.1,0-0.1-0.1-0.2-0.1c-1.3-0.5-1.9-1.4-1.9-2.7c0-0.3,0-0.6,0-0.9 C0.4,21,0,20.7,0,20.1c0-2.2,0-4.3,0-6.5c0-0.6,0.4-0.9,0.9-1c0.1,0,0.2,0,0.4-0.1c0-0.2,0-0.4,0-0.6c0-3,0-6.1,0-9.1 C1.3,1.1,2.5,0,4.1,0c3.2,0,6.4,0,9.6,0c0.2,0,0.5,0.1,0.6,0.3c1.9,1.9,3.9,3.8,5.8,5.8c0.2,0.2,0.3,0.4,0.3,0.7 c0,1.6,0,3.2,0,4.9c0,3.6,0,7.1,0,10.7c0,1.4-0.7,2.3-2,2.7C18.3,24.9,18.2,25,18.2,25z M13.4,1.6c-0.2,0-0.3,0-0.4,0 c-2.9,0-5.8,0-8.7,0C3.3,1.6,3,2,3,2.9C3,6,3,9,3,12c0,0.2,0,0.3,0,0.5c0.2,0,0.4,0,0.5,0c4,0,8,0,12,0c0.9,0,1.3,0.4,1.3,1.3 c0,2,0,3.9,0,5.9c0,1.1-0.4,1.4-1.4,1.4c-3.9,0-7.9,0-11.8,0c-0.2,0-0.4,0-0.7,0c0,0.4,0,0.7,0,1c0,0.9,0.4,1.3,1.3,1.3 c4.4,0,8.8,0,13.2,0c0.9,0,1.3-0.4,1.3-1.3c0-4.9,0-9.7,0-14.6c0-0.2,0-0.3,0-0.5c-1,0-2,0-3,0c-1.5,0-2.2-0.7-2.2-2.2 C13.4,3.7,13.4,2.7,13.4,1.6z M6.7,14.7c0,1.5,0,2.8,0,4.2c0,0.1,0.2,0.3,0.3,0.3c0.7,0,1.4,0,2.1-0.1c1.1-0.2,1.7-1.2,1.6-2.4 c-0.1-1.1-0.7-1.8-1.9-1.9C8.1,14.6,7.5,14.7,6.7,14.7z M3.8,19.2c0-0.5,0-1,0-1.5c0.5-0.1,1-0.2,1.4-0.3c0.6-0.2,0.9-0.8,0.8-1.4 c0-0.6-0.4-1-1-1.2c-0.7-0.2-1.5-0.1-2.2,0c0,1.5,0,2.9,0,4.4C3.2,19.2,3.5,19.2,3.8,19.2z M12.4,19.2c0-0.6,0-1.2,0-1.8 c0.6,0,1.1,0,1.6,0c0-0.3,0-0.5,0-0.8c-0.5,0-1,0-1.6,0c0-0.3,0-0.6,0-1c0.6,0,1.1,0,1.7,0c0-0.3,0-0.6,0-0.8c-0.9,0-1.8,0-2.7,0 c0,1.5,0,3,0,4.5C11.7,19.2,12,19.2,12.4,19.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M7.8,15.5c0,1,0,2,0,2.9c0.7,0.1,1.3-0.1,1.6-0.5c0.3-0.5,0.3-1.4,0-1.9C9,15.4,8.4,15.4,7.8,15.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M3.9,16.8c0-0.4,0-0.8,0-1.3c0.3-0.2,0.7-0.2,1,0.1C5,15.8,5,16.2,4.9,16.4C4.8,16.8,4.3,16.8,3.9,16.8z"
})));

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.4 25",
    style: {
      enableBackground: "new 0 0 20.4 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PDF.70fae8fb.svg";
export { ForwardRef as ReactComponent };